'use client';
import { jsx } from 'react/jsx-runtime';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, i = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, i = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
const PriceBarPriceInfo = renderWithRef('PriceBarPriceInfo', null, (o, s)=>{
    let a = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('PriceBarPriceInfo', o, [
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(a)
        }
    ]);
    let { accessibleText: f } = o, l = _object_without_properties(o, [
        "accessibleText"
    ]), m = f;
    return a && !f && (m = a.t('price-bar-price-info.accessible-text-for-icon-button')), jsx(RenderComp, {
        root: "div",
        forwardedRef: s,
        classNames: new Set([
            'swan-price-bar-price-info'
        ]),
        props: l,
        children: jsx(Button, {
            skin: "unstyled",
            children: jsx(Icon, {
                alt: m || '',
                iconType: "info",
                size: "16p"
            })
        })
    });
});

export { PriceBarPriceInfo };
